module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-02.1@2x.017c9796.jpg";